// Imports
import { Route } from 'react-router-dom';
import Billing from '.';
import Receipt from './receipt';
import UpsertPaymentMethod from './upsert';


// Function component
const sectionRoutes = (
	<Route path='billing'>
		<Route index element={<Billing />} />
		<Route path='add-payment-method' element={<UpsertPaymentMethod />} />
		<Route path='replace-payment-method' element={<UpsertPaymentMethod replace />} />
		<Route path='transaction/:transactionID/receipt' element={<Receipt />} />
	</Route>
);

export default sectionRoutes;
